import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { JSONStringify, ParseQueryType } from 'zigra-ng-framework';
import {
    GraphQLResponse,
    InvoiceType,
    InvoiceTypeQuery,
    ProviderSignatureType,
    ProviderSignatureTypeQuery
} from '../zigra-schema.autogenerated.models';

@Injectable()
export class PostInvoicesToAADESchema {
    //private schemaEndPoint = 'https://localhost:7043/graphql/Authorized/Solutions';
    protected entityName: string = 'PostInvoicesToAADE';
    protected schemaEndPoint = `${environment.graphQLEndPoint}/Authorized/PostInvoicesToAADE`;

    constructor(protected http: HttpClient) {}

    public PostInvoicesToAADE(invoice: InvoiceType, query: InvoiceTypeQuery) {
        debugger;
        const sQuery = `mutation PostInvoicesToAADE {
            PostInvoicesToAADE(Invoice: ${JSONStringify(invoice)}) 
             { ${ParseQueryType<InvoiceTypeQuery>(query)} }  
        }`;

        return this.http.post<
            | GraphQLResponse<{
                  PostInvoicesToAADE: InvoiceType | undefined;
              }>
            | undefined
        >(this.schemaEndPoint, {
            query: sQuery
        });
    }

    public AskSignatureForOldInvoice(
        invoice: InvoiceType,
        query: ProviderSignatureTypeQuery
    ) {
        debugger;
        const sQuery = `mutation AskSignatureForOldInvoice {
            AskSignatureForOldInvoice(Invoice: ${JSONStringify(invoice)}) 
             { ${ParseQueryType<InvoiceTypeQuery>(query)} }  
        }`;

        return this.http.post<
            | GraphQLResponse<{
                  AskSignatureForOldInvoice: ProviderSignatureType | undefined;
              }>
            | undefined
        >(this.schemaEndPoint, {
            query: sQuery
        });
    }

    public CompletionAskSignatureForOldInvoice(
        invoice: InvoiceType,
        signatureToken: string,
        transactionId: string,
        paymentAmount: number,
        tipAmount: number,
        query: InvoiceTypeQuery
    ) {
        debugger;
        const sQuery = `mutation CompletionAskSignatureForOldInvoice {
            CompletionAskSignatureForOldInvoice(Invoice: ${JSONStringify(invoice)}, SignatureToken: '${signatureToken}', TransactionId: ${transactionId}, PaymentAmount: ${paymentAmount}, TipAmount: ${tipAmount}   ) 
             { ${ParseQueryType<InvoiceTypeQuery>(query)} }  
        }`;

        return this.http.post<string | undefined>(this.schemaEndPoint, {
            query: sQuery
        });
    }
}
